// src/components/Countries/CountryForm.js
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Button } from 'antd';
import { createCountry, updateCountry, fetchCountryById } from '../../../redux/Country/actions';

const CountryForm = ({ _id, onClose }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { country } = useSelector(state => state.countries);

  useEffect(() => {
    if (_id) {
      dispatch(fetchCountryById(_id));
    }
  }, [dispatch, _id]);

  useEffect(() => {
    if (country) {
      form.setFieldsValue({ name: country.name });
    } else {
      form.resetFields();
    }
  }, [country, form]);

  const onFinish = (values) => {
    if (_id) {
      dispatch(updateCountry(_id, values));
    } else {
      dispatch(createCountry(values));
    }
    onClose();
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
    >
      <Form.Item
        label="Country Name"
        name="name"
        rules={[{ required: true, message: 'Please input the country name!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          {_id ? 'Update Country' : 'Add Country'}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CountryForm;
